// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ddfc383e","363":"68c15b3c","765":"62bf9bb2"}[chunkId] + ".chunk.js";
};